/*
 * Public API Surface of ngx-tippy-wrapper
 */

export { NgxTippyGroupComponent, NgxTippySingletonComponent } from './lib/components';
export { NgxTippyDirective } from './lib/ngx-tippy.directive';
export {
  InstanceChangeReason,
  InstancesChanges,
  NgxSingletonProps,
  NgxTippyContent,
  NgxTippyDefaultProps,
  NgxTippyHideAllOptions,
  NgxTippyInstance,
  NgxTippyProps,
  NgxTippySingletonInstance,
  NgxTippyTemplate,
} from './lib/ngx-tippy.interfaces';
export { NgxTippyModule } from './lib/ngx-tippy.module';
export { NgxTippyService } from './lib/services';
export { NGX_TIPPY_CONFIG } from './lib/ngx-tippy.tokens';
